exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content_container{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n}\n\n.content_list {\n  font-size:  18px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.content_list_item {\n  width: 100%;\n  padding: 6px 6px 6px 6px;\n  border: 1px solid #4a7ebb;\n  margin-bottom: 6px;\n  background-color: #113972;\n}\n\n.header_content {\n  text-align: center;\n  font-size:  22px;\n  margin-bottom: 50px;\n  background-color: #113972;\n  border: 1px solid #4a7ebb;\n  padding: 6px 6px 6px 6px\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users.component.css
// module id = 404
// module chunks = 2